import { render, staticRenderFns } from "./pedidosAdmin.vue?vue&type=template&id=7d0bae43"
import script from "./pedidosAdmin.vue?vue&type=script&lang=js"
export * from "./pedidosAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports